import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import StyledMenu from './StyledMenu'

/**
 *
 * @param {{children: JSX.Element[], buttonLabel: string}} props
 * @returns
 */
const StyledDropdownMenu = ({ children, buttonLabel = 'Actions' }) => {
	const [anchorEl, setAnchorEl] = useState(null)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<div>
			<Button
				variant="outlined"
				color="secondary"
				style={{ paddingLeft: '22px', paddingRight: '22px' }}
				endIcon={<i className="fa fa-caret-down" />}
				onClick={(e) => handleClick(e)}>
				{buttonLabel}
			</Button>
			<StyledMenu
				id="styled-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}>
				{children}
			</StyledMenu>
		</div>
	)
}

export default StyledDropdownMenu
